// Thin wrapper around GET /api/search — the global smart search fan-out.
// Project scope rides on the X-Cortex-Project/-Branch headers fetchData
// derives from the URL, so the active project needs no explicit argument.
import { fetchData } from '../fetchapi/fetchapi';

export async function searchGlobal(q, { limit } = {}) {
  const params = new URLSearchParams({ q });
  if (limit) params.set('limit', String(limit));
  const res = await fetchData(`search?${params.toString()}`);
  return res?.groups || [];
}
